import { combineReducers } from 'redux';

// Reducers
import externalSystemSettingReducer from './ExternalSystemSetting/store/externalSystemSettingReducer';

export const subComponents = (translations) => [
    { name: translations["external_system_setting"] || "External system setting", path: "/externalSystemSetting", permissions: ["external_system_setting_list"] },
]

export const reducers = combineReducers({
    externalSystemSetting: externalSystemSettingReducer
});

